import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EfSwiperCardBundle, { EfSwiperCardBundleProps } from '@elem/ui/ef-swiper-card-bundle';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import { dataLocal } from './configs';
import { useState, useEffect } from 'react';
import { getSolarRecommand } from '@/service/solar-calculator';

const Bundles: React.FC = () => {
    const { t } = useLang('d3u.bundles');
    const { locale = '' } = useRouter();
    const data = dataLocal[locale];
    const { data1, data2 } = data;

    const [data1State, setData1State] = useState<EfSwiperCardBundleProps[]>(data1);
    const [data2State, setData2State] = useState<EfSwiperCardBundleProps[]>(data2);

    const getAsynItem = async (item: EfSwiperCardBundleProps) => {
        const { productId = '', variantId = '' } = item.info;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    item.items[0].variantImg = res?.data?.variantImg || '/';
                    item.items[0].img = res?.data?.img || '/';
                    item.info.linkMoreText = t('link_buy');
                    if (res?.data?.handle) {
                        item.info.linkMore = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                    }
                    item.info = { ...item.info, ...res?.data };
                    return resolve(item);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        [data1State, data2State].map((data: EfSwiperCardBundleProps[], k: number) => {
            const tempData = JSON.parse(JSON.stringify(data));
            const dataPromises: Promise<EfSwiperCardBundleProps>[] = tempData?.map((item: EfSwiperCardBundleProps) => getAsynItem(item));
            Promise.all(dataPromises)
                .then((res: EfSwiperCardBundleProps[]) => {
                    switch (k) {
                        case 0:
                            setData1State(res);
                            break;
                        case 1:
                            setData2State(res);
                            break;
                        default:
                            break;
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        });
    }, []);

    return (
        <div className={css.bundles}>
            <EfSpec className="spec" />
            <EfTitle hasAnimation={false}>{t('A_title')}</EfTitle>
            <ul className="items">
                {data1State?.map((item: EfSwiperCardBundleProps, k: number) => (
                    <EfSwiperCardBundle {...item} key={k} list_name={t('A_title')} />
                ))}
            </ul>
            <EfSpec className="spec" />
            <EfTitle hasAnimation={false}>{t('B_title')}</EfTitle>
            <ul className="lists">
                {data2State?.map((item: EfSwiperCardBundleProps, k: number) => (
                    <EfSwiperCardBundle {...item} key={k} list_name={t('B_title')} />
                ))}
            </ul>
            <EfSpec className="spec" />
        </div>
    );
};

export default Bundles;
